import { Button, Modal } from "antd";
import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import EasyButton from "../../components/easy-button";
import { BookMark } from "../../components/book-mark";
import "./book-item.scss";

interface BookItemProps {
    title: string;
    imageTitle: string;
    detailedDescription: any;
    coverImage: any;
    summaryDescription: any;
    bookLink: any;
    isBookMarkVisible: boolean;
}
interface BookItemState {
    IsVisibleBookDetail: boolean;
}

class BookItem extends React.Component<BookItemProps, BookItemState>{
    constructor(props: any) {
        super(props);
        this.state = {
            IsVisibleBookDetail: false
        };
    }

    handleModalClose = () => {
        this.setState({ IsVisibleBookDetail: false });
    }
    handleModalOpen = () => {
        this.setState({ IsVisibleBookDetail: true });
    }

    render() {
        return (
            <div className="books">
                <figure className="book">
                    <figcaption>{this.props.title}</figcaption>
                    <img src={this.props.coverImage} alt={this.props.imageTitle} />

                    <BookMark bookLink={this.props.bookLink} isBookMarkVisible={this.props.isBookMarkVisible} />

                    <div className="summary-description">
                        {this.props.summaryDescription}
                    </div>

                    <EasyButton
                        title="Detay"
                        onClick={this.handleModalOpen}
                    />
                </figure>

                <Modal
                    width="auto"
                    bodyStyle={{ overflow: 'auto', minHeight: 200, maxHeight: 'calc(100vh - 200px)', maxWidth: 800 }}
                    className="book-content__modal"
                    title={this.props.title}
                    open={this.state.IsVisibleBookDetail}
                    maskClosable={true}
                    closable={true}
                    centered={true}
                    onCancel={(e: any) => {
                        e.stopPropagation();
                        this.handleModalClose();
                    }}
                    closeIcon={<AiFillCloseCircle size={40} color="#f50057" onClick={this.handleModalClose} />}
                    footer={[
                        <Button
                            className="modal-footer-button"
                            onClick={() => { this.handleModalClose() }}
                            title="Kapat"
                            type='text'
                        >Kapat</Button>
                    ]}
                >
                    {this.props.detailedDescription}
                </Modal>
            </div>
        );
    }
}

export default BookItem;